import { createSelector } from 'reselect';

const getAppState = (state) => state.app;

// eslint-disable-next-line import/prefer-default-export
export const getAPIStatus = createSelector(
    getAppState,
    (appState) => appState.apiStatus,
);
